/* eslint-disable react/require-default-props */
import React from "react";
import {Brands, styled, getFont, Theme} from "@core-ui/react-stitch";
import {InternalModalProps} from "../types";

type HeaderProps = Pick<InternalModalProps, "crossBrand" | "title"> & {
  closeButton: React.ReactNode;
  id: string;
  isBRRedesignEnabled?: boolean;
  className?: string;
};

const Title = styled.h2<
  Pick<HeaderProps, "crossBrand" | "isBRRedesignEnabled">
>`
  ${getFont("primary")}
  font-size: ${({isBRRedesignEnabled}) =>
    isBRRedesignEnabled ? "0.938rem" : "1rem"};
  line-height: ${({isBRRedesignEnabled}) =>
    isBRRedesignEnabled ? "1.188rem" : "1.6rem"};
  align-self: center;
  text-transform: uppercase;
  ${({theme, isBRRedesignEnabled}) =>
    isBRRedesignEnabled
      ? `
    color: ${theme.color.inverse.b1};
    font-weight: 350;
  `
      : ""}
`;

const isBr = (theme: Theme) =>
  theme.brand === Brands.BananaRepublic ||
  theme.brand === Brands.BananaRepublicFactoryStore;

const getFontColorHeader = ({
  theme,
  hasTitle,
  isBRRedesignEnabled,
}: {
  theme: Theme;
  hasTitle: boolean;
  isBRRedesignEnabled?: boolean;
}) => {
  if (isBr(theme)) {
    return isBRRedesignEnabled ? theme.color.b2 : theme.color.inverse.b2;
  }
  return theme.color[hasTitle ? "gray05" : "wh"];
};

const HeaderContainer = styled.div<{
  hasTitle: boolean;
  isBRRedesignEnabled?: boolean;
}>`
  width: 100%;
  position: relative;
  box-sizing: border-box;
  display: flex;
  min-height: 2.5rem;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  background-color: ${({theme, hasTitle, isBRRedesignEnabled}) =>
    getFontColorHeader({theme, hasTitle, isBRRedesignEnabled})};
  z-index: ${({theme}) => theme.layers.modalHeader};
`;

const Header = ({
  closeButton,
  crossBrand,
  id,
  isBRRedesignEnabled,
  title,
}: HeaderProps): JSX.Element => (
  <HeaderContainer
    hasTitle={Boolean(title)}
    isBRRedesignEnabled={isBRRedesignEnabled}
  >
    <Title
      crossBrand={crossBrand}
      id={id}
      isBRRedesignEnabled={isBRRedesignEnabled}
    >
      {title}
    </Title>
    {closeButton}
  </HeaderContainer>
);

export default Header;
